const getColumnKey = (column) => {
  if (!column || typeof column !== 'object') return null

  // 兼容旧缓存将 undefined 序列化为字符串的情况。
  const field = [column.prop, column.props].find(
    (value) => value && value !== 'undefined'
  )
  if (field) return `prop:${field}`
  if (column.type && column.type !== 'undefined') return `type:${column.type}`
  return column.label ? `label:${column.label}` : null
}

const isStructuralColumn = (column) =>
  ['selection', 'index', 'expand'].includes(column.type)

/**
 * 当前表头决定列定义，缓存只决定仍然存在的业务列的顺序。
 * 删除的列直接丢弃，新增列补到业务列末尾，特殊列保留配置中的位置。
 */
export function restoreTableHeader(header, cachedColumns) {
  if (!Array.isArray(cachedColumns)) return header

  const remaining = header.filter((column) => !isStructuralColumn(column))
  const ordered = []

  cachedColumns.forEach((cached) => {
    const key = getColumnKey(cached)
    if (!key) return

    const index = remaining.findIndex((column) => getColumnKey(column) === key)
    if (index !== -1) ordered.push(...remaining.splice(index, 1))
  })
  ordered.push(...remaining)

  let index = 0
  return header.map((column) =>
    isStructuralColumn(column) ? column : ordered[index++]
  )
}
